<template>
	<div class="detail-view shower">
		<shower-fashion-closet-page></shower-fashion-closet-page>
	</div>
</template>

<script>
import ShowerFashionClosetPage from "../components/pages/ShowerFashionClosetPage";
export default {
  name: "ShowerFashionCloset",
  components: {ShowerFashionClosetPage},
}
</script>

<style lang="scss" scoped>
    // .detail-view {
    //   &.shower {
    //     padding: 0;
    //   }
    // }
</style>
